import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import {
  sortableField,
  columnTextField,
  columnNumberField,
  columnPriceField,
  columnDecimalField,
} from "utils/tables-utils";

const columnModel = [
  {
    dataField: "UrlFoto",
    text: "Foto do produto",
    align: "center",
    headerAlign: "center",
    isDummyField: true,
    formatter: (cell, row) => (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ImagePlaceholder
          src={row.UrlFoto}
          alt="Foto do produto"
          width={50}
          widthOnError={40}
          imagePreviewTitle={`Produto ${row.IdProduto}`}
        />
      </div>
    ),
    csvExport: true,
  },
  columnTextField(
    {
      dataField: "MarcaNome",
      text: "Marca",
    },
    true
  ),
  columnTextField(
    {
      dataField: "Linha",
      text: "Linha",
    },
    true
  ),
  columnNumberField(
    {
      dataField: "IdProduto",
      text: "Código",
    },
    true
  ),
  columnTextField(
    {
      dataField: "DescricaoLiteralProduto",
      text: "Descrição",
    },
    true
  ),
  sortableField({
    dataField: "StatusProdutoCiclo",
    text: "Status Ciclo",
    align: "center",
    headerAlign: "center",
  }),
  columnTextField(
    {
      dataField: "NomeColecao",
      text: "Nome Coleção",
    },
    true
  ),
  sortableField({
    dataField: "Tamanho",
    text: "Tamanho",
    align: "center",
    headerAlign: "center",
  }),
  columnDecimalField(
    {
      dataField: "PTC",
      text: "PTC",
    },
    true
  ),
  sortableField({
    dataField: "QuantidadeDisponivel",
    text: "Qtde em estoque",
    align: "right",
    headerAlign: "center",
  }),
  columnNumberField(
    {
      dataField: "DiasSemVenda",
      text: "Dias sem venda",
    },
    true
  ),
  columnPriceField(
    {
      dataField: "Preco",
      text: "Preço",
    },
    true
  ),
  columnDecimalField(
    {
      dataField: "Margem",
      text: "Margem",
    },
    true
  ),
  columnDecimalField(
    {
      dataField: "Markup",
      text: "Markup",
    },
    true
  ),
];

export default function TableSemVenda({ dataTable }) {
  return (
    <ToolkitTable
      searched={Boolean(dataTable)}
      keyField="IdProduto"
      dataTable={dataTable}
      columnModel={columnModel}
      headerTitle={`Produtos sem venda`}
      csvFileName="ProdutosSemVenda.csv"
      pagination={{
        options: [25, 50, 100],
        defaultOption: 25,
      }}
      showPrint
      notFoundTitle="Sua pesquisa não encontrou nenhum produto correspondente."
    />
  );
}
